'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingLabel = undefined;

var _Base = require('../Base');

var FloatingLabel = exports.FloatingLabel = (0, _Base.simpleTag)({
  displayName: 'FloatingLabel',
  tag: 'label',
  classNames: function classNames(props) {
    return ['mdc-floating-label', {
      'mdc-floating-label--float-above': props.value || props.focused
    }];
  },
  consumeProps: ['value', 'focused']
});

exports.default = FloatingLabel;
